module.exports = __webpack_public_path__ + "static/media/product_19.373c1c25.jpg";